import router from './router/index'
import { getToken } from '@/utils/auth'


// 白名单列表 不限制登陆条件的访问页面列表
const whiteList = [
    '/start',
    '/query',
    '/home',
    '/auth',
    '/fission'
]

// 路由拦截
router.beforeEach((to, from, next) => {
    const token = getToken()
    if (token && token != '') {
        next()
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            const back = encodeURIComponent(document.URL)
            const base = window.location.origin + window.location.pathname
            // pathname 后面已经有 path 了
            next({
                // path: '/home',
                name: 'home',
                params: {
                    back: encodeURIComponent(back),
                }
            })
        }
    }
    //   console.log({from, to})
})

router.afterEach((to, from) => {
    //   console.log("------- afterEach -------", from.path, '->', to.path);
})
